var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progressDialog" }, [
    _c("span", [
      _vm._v(
        _vm._s(_vm.label) + ": " + _vm._s(String(_vm.valuePercentage)) + "%"
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.valuePercentage > 0,
            expression: "valuePercentage > 0",
          },
        ],
        staticClass: "progressBar",
      },
      [
        _c(
          "div",
          {
            staticClass: "progressValue",
            style: { width: _vm.valuePercentage + "%" },
          },
          [_vm._v(" ")]
        ),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.valuePercentage < 1,
            expression: "valuePercentage < 1",
          },
        ],
      },
      [_c("br"), _c("div", { staticClass: "loadingBar" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }